import { Amplify } from 'aws-amplify';

// get actual domain
let actualDomain = window.location.hostname;
if (actualDomain !== 'localhost') {
  actualDomain = actualDomain.split('.').slice(-2).join('.');
}

// Debug: Log environment variables
console.log('Environment variables:', {
  NX_COGNITO_REGION: import.meta.env.NX_COGNITO_REGION,
  NX_COGNITO_IDENTITY_ID: import.meta.env.NX_COGNITO_IDENTITY_ID,
  NX_COGNITO_POOL_ID: import.meta.env.NX_COGNITO_POOL_ID,
  NX_COGNITO_POOL_WEB_CLIENT: import.meta.env.NX_COGNITO_POOL_WEB_CLIENT,
  NX_COGNITO_POOL_DOMAIN: import.meta.env.NX_COGNITO_POOL_DOMAIN,
});

// review https://stackoverflow.com/questions/79011379/using-cookies-storage-on-next-js-app-with-amplify-auth
export const amplifyConfig = {
  Auth: {
    // cookieStorage: {
    //   // - Cookie domain (only required if cookieStorage is provided)
    //   domain: actualDomain,
    //   // (optional) - Cookie path
    //   path: '/',
    //   // (optional) - Cookie expiration in days
    //   expires: 365,
    //   // (optional) - See:
    //   // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
    //   sameSite: 'none',
    //   // (optional) - Cookie secure flag
    //   // Either true or false, indicating if the cookie
    //   // transmission requires a secure protocol (https).
    //   secure: true,
    // },
  },
  aws_project_region: import.meta.env.NX_COGNITO_REGION,
  aws_cognito_identity_pool_id: import.meta.env.NX_COGNITO_IDENTITY_ID,
  aws_cognito_region: import.meta.env.NX_COGNITO_REGION,
  aws_user_pools_id: import.meta.env.NX_COGNITO_POOL_ID,
  aws_user_pools_web_client_id: import.meta.env.NX_COGNITO_POOL_WEB_CLIENT,
  oauth: {
    domain: import.meta.env.NX_COGNITO_POOL_DOMAIN,
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: 'http://localhost:4200/',
    redirectSignOut: 'http://localhost:4200/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['GOOGLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'amplify-amplifyb609f40b93324-staging-31035-deployment',
  aws_user_files_s3_bucket_region: 'us-east-1',
  aws_cloud_logic_custom: [
    {
      name: 's360',
      endpoint: 'https://zerbximind.execute-api.us-east-1.amazonaws.com/pruebas',
      region: 'us-east-1',
    }
  ],
};
console.log('amplifyConfig', amplifyConfig);

// Configure Amplify immediately at module load time (before any React rendering)
// This ensures configuration is applied before any auth functions are called
console.log('[amplifyConfig.js] Configuring Amplify at module load time...');

const amplifyV6Config = {
  Auth: {
    Cognito: {
      userPoolId: amplifyConfig.aws_user_pools_id,
      userPoolClientId: amplifyConfig.aws_user_pools_web_client_id,
      identityPoolId: amplifyConfig.aws_cognito_identity_pool_id,
      loginWith: {
        oauth: {
          domain: amplifyConfig.oauth.domain,
          scopes: amplifyConfig.oauth.scope,
          redirectSignIn: [`${window.location.protocol}//${window.location.host}/sign-in/verifying`],
          redirectSignOut: [`${window.location.protocol}//${window.location.host}/sign-in`],
          responseType: 'code',
        },
      },
    },
  },
};

console.log('[amplifyConfig.js] Amplify v6 config:', amplifyV6Config);

try {
  Amplify.configure(amplifyV6Config);
  console.log('[amplifyConfig.js] ✅ Amplify configured successfully at module load time');
} catch (error) {
  console.error('[amplifyConfig.js] ❌ Error configuring Amplify:', error);
}

export default amplifyConfig;
